import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from '@app/core/i18n.service';

/*
 * A locale selector component that pulls the supported locales from the environment file,
 * and allows the user to change the locale used by the i18n service and set in local storage.
 * Optional Output: emits the locale to be used by the parent component.
 * Optional Input: overrides the supported locales for the selector.
 */
@Component({
    selector: 'app-locale-select',
    templateUrl: 'locale-select.component.html',
    styleUrls: ['locale-select.component.scss']
})
export class LocaleSelectComponent {


    /************************************************************************************************************
     * @Decorators variables
     ***********************************************************************************************************/

    // Optional: locale emitter, used for the toolbar implementation
    @Output() localeChange = new EventEmitter<string>();

    /** */
    @Input() showIcon!: boolean;

    /************************************************************************************************************
     * @Callback functions
     ***********************************************************************************************************/
    
    /** */
    valueAscendingOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => { return a.value.localeCompare(b.value); };


    /************************************************************************************************************
     * @Predefined variables
     ***********************************************************************************************************/

    LANGUAGE_NATIVE_MAP: {[code: string]: string} = {
        'en-ca': 'English (Canada)',
        'fr-ca': 'Français (Canada)',
        'fr-be': 'Français (Belgique)',
        'it-it': 'Italiano',
        'es-es': 'Español',
        'pt-br': 'Português Brasileiro',
    }

    nativeLocales: { [code: string]: string} = {}


    /************************************************************************************************************
     * @Constructor
     ***********************************************************************************************************/
    
    constructor(protected i18nService: I18nService) {
        /** */
        Object.keys(this.i18nService.locales).forEach(key => {
            key in this.LANGUAGE_NATIVE_MAP ?
                this.nativeLocales[key] = this.LANGUAGE_NATIVE_MAP[key]
                :
                this.nativeLocales[key] = 'DATA_MISSING'
        })
    }


    /************************************************************************************************************
     * @protected methods
     ***********************************************************************************************************/

    /** */
    protected onChange(selectedLocale: string) {
        const currentLangPathname = `/${this.i18nService.selectedLocaleId.toLocaleLowerCase()}`;
        let effectivePathname =  location.pathname.toLocaleLowerCase().startsWith(currentLangPathname)
            ? `/${selectedLocale.toLocaleLowerCase()}${location.pathname.substring(currentLangPathname.length)}`
            : location.pathname;
        location.href = `${location.origin}${effectivePathname}${location.search}`;
        this.localeChange.emit(selectedLocale);
    }
}
